<template>
  <div>

    <v-app-bar 
      v-if="user.roles.some(role => role === 'admin' || role === 'organizer')"
      class="color-app-bar" 
      app 
      dark>
      
      <v-app-bar-nav-icon 
        @click="menu" 
        v-if="isLogged">
      </v-app-bar-nav-icon>
      <v-toolbar-title> 
        <b><b>JIJE</b></b> UNL
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!$vuetify.breakpoint.xsOnly"
            min-width="240px"
            outlined
            color="white"
            small
            v-show="isLogged"
            v-bind="attrs"
            v-on="on"
          >
            {{ (user!==null)?user.lastname+', '+user.name:'' }}
          </v-btn>

          <v-avatar 
            v-if="$vuetify.breakpoint.xsOnly"
            class="ma-2"
            v-show="isLogged"
            v-bind="attrs"
            v-on="on"
            size="42"
            color="white">
            <span class="black--text text-h7">
              {{ (user!==null)?user.name[0]+user.lastname[0]:'' }}
            </span>
          </v-avatar>
        </template>

        <v-list color="#1F5367">
          <v-list-item>
            <v-btn
              block
              outlined
              dark
              :to="{name: 'profile'}">
              Editar Perfíl
            </v-btn>
          </v-list-item>

          <v-list-item>
            <v-btn
              block
              outlined
              dark
              @click="logout">
              Cerrar sesión
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    
    <v-navigation-drawer 
      dark
      app
      color="black"
      v-model="drawer">
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-rocket-launch</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <h4>JIJE UNL</h4>
        </v-list-item-content>
      </v-list-item>

      <v-list 
        dense 
        nav
        v-if="user.roles.find(element => element =='admin')">
        <v-divider></v-divider>
          <v-list-item-title class="pl-8 pa-2"> Administrador </v-list-item-title>
        <v-divider></v-divider>
        
        <v-list-item router to="/admin/editions">
          <v-list-item-icon>
            <v-icon>mdi-trophy-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Ediciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/indicators">
          <v-list-item-icon>
            <v-icon>mdi-chart-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Indicadores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/entrepreneurships">
          <v-list-item-icon>
            <v-icon>mdi-menu</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Emprendimientos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/project-gallery">
          <v-list-item-icon>
            <v-icon>mdi-view-gallery-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Galeria de Emprendimientos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/entrepreneurs">
          <v-list-item-icon>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Emprendedores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/general-public">
          <v-list-item-icon>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Público General</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/landing">
          <v-list-item-icon>
            <v-icon>mdi-image-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Landing Page</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item router to="/admin/evaluators">
          <v-list-item-icon>
            <v-icon>mdi-school-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Evaluadores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/tutors">
          <v-list-item-icon>
            <v-icon>mdi-human-male-board-poll</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Tutores</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item router to="/admin/users">
          <v-list-item-icon>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Usuarios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/admin/config">
          <v-list-item-icon>
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Configuraciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


      </v-list>

      <v-list 
        dense 
        nav
        v-if="user.roles.find(element => element =='organizer')">
        <v-divider></v-divider>
          <v-list-item-title class="pl-8 pa-2"> Organizador </v-list-item-title>
        <v-divider></v-divider>
        
        <v-list-item router to="/organizer/entrepreneurships">
          <v-list-item-icon>
            <v-icon>mdi-menu</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Emprendimientos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router :to="{ name: 'standsOrganizer' }">
          <v-list-item-icon>
            <v-icon>mdi-view-gallery-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Galeria de Emprendimientos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router to="/organizer/entrepreneurs">
          <v-list-item-icon>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Emprendedores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'AppBarAdminOrganizer',
  // props: ['drawer'],
  data: () => ({

    currenRoute:null,
    show_access:false,
    show_login: false,
    show_register: false,

    access_enabled: false,

    entrepreneur_role:false,
    admin_role:false,
    evaluator_role:false,
    state_convocation_form:[]
  }),

  computed: {
    ...mapGetters([
      'isLogged', 'user', 'convocation_form', 'edition', 'edition_id', 'drawer'
    ]),

    drawer: {
      get() {
        return this.$store.getters.drawer;
      },
      set(value) {
        this.$store.commit('setDrawer', value);
      },
    },
  },

  watch: {
    '$route': 'currentRoute'
  },

  methods: {
    currentRoute() {
      this.$nextTick(() => {
        this.currenRoute = this.$route.name

        switch (this.currenRoute) {
          case 'UNLPotencia':
            this.show_access = true;
            this.show_login = false;
            this.show_register = false;
            this.$store.dispatch('setDrawer', false);
            break;
          
          case 'editions':
            this.show_access = true;
            this.show_login = false;
            this.show_register = false;
            this.$store.dispatch('setDrawer', true);
            break;
            

          case 'login':
            this.show_access = false;
            this.show_login = true;
            this.show_register = false;
            this.$store.dispatch('setDrawer', false);
            break;
          
          case 'register':
            this.show_access = false;
            this.show_login = false;
            this.show_register = true;
            this.$store.dispatch('setDrawer', false);
            break;
        
          default:
            this.show_access = false;
            this.show_login = false;
            this.show_register = false;
            break;
        }
      });
    },

    login(){
      if(this.$route.name=='register'){
        this.currenRoute = 'login'
      }
      this.$router.push({ name: "login"})
    },

    register(){
      if(this.$route.name=='login'){
        this.currenRoute = 'register'
      }
      this.$router.push({ name: "register"})
    },

    access(){
      if(this.$route.name=='UNLPotencia'){
        this.currenRoute = 'UNLPotencia'
      }
    },

    async logout() {
      await axios.post('logout').then(() =>{ 
          this.drawer = false
          this.$router.push({ name: "index"})
          this.$store.dispatch('logout')
        }).catch(error => {
          console.log(error);
        })
    },

    menu(){
      this.drawer = !this.drawer
    },

    checkRoles(){
      if(this.user!=null){
        const found = this.user.find(element => element == 'entrepreneur');
        return found;
      }
    },

    async getStatus(){
      if(this.convocation_form!=null){
        await axios.get('convocation/status/'+this.convocation_form.convocation_form.id).then((response) =>{
          this.state_convocation_form=response.data.status;
          this.loading=false;
        }).catch(error => {
          console.log(error);
        })
      }
    },

    async getInfoAccess(){
      await axios.get('edition/'+this.convocation_form.convocation_form.edition_id).then(response => {
          this.access_enabled = response.data.data.edition.access_enabled
        }).catch(()=>{
          this.$router.push({ name: 'login' })
        })
    }
  },

  created(){
    Promise.all([
      this.currentRoute(),
      // this.getStatus(),
      // this.getInfoAccess()
    ]).then(() => {
      this.drawer = true
    }).catch((error) => {
      console.log(error)
    });
  }
  
}
</script>
<style>
.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}

.routerLink{
  text-decoration: none;
}

.app-bar-color {
  color: white!important;
}

.color-navigation2 {
  color: white!important;
  background-color: powderblue!important;
}

.color-navigation1 {
  color: white!important;
  background: repeating-linear-gradient(rgb(105, 105, 105),rgb(105, 105, 105));
}

.color-navigation {
  color: white !important;
  background: repeating-linear-gradient(#32378B, #A21381, #E2017B, #A6C400, #B5C500);
  /* background: repeating-linear-gradient(#000000,#176E81, #0D849A, #000000, #000000); */
  /* background: repeating-linear-gradient(#23495C, #23495C); */
}

</style>